import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as rxjs from 'rxjs'

import * as routeBound from '../../../../route-bound'
import * as records from '../../records'

import { Api } from './api.service'
import associations from './associations'
import * as effects from './effects'
import type { TypeParams } from './types'

/**
 * Occupants collection for fetching space record occupants
 */
@ngCore.Injectable()
export class Collection extends ec.Collection<TypeParams, typeof associations> {
  constructor() {
    const scenarioContext = ngCore.inject(routeBound.scenario.Context.TOKEN)
    const recordsEc = ngCore.inject(records.Collection)

    super({
      api: ngCore.inject(Api),
      associations,
      context$: rxjs
        .combineLatest([
          scenarioContext,
          recordsEc.plugins.currentEntityPlugin.feature.selectors.getId()
            .asObservable,
        ])
        .pipe(
          rxjs.map(([context, spaceRecordId]) => {
            if (!context || !ents.core.dms.data.Record.Id.isId(spaceRecordId)) {
              return undefined
            }

            return { ...context, spaceRecordId }
          }),
        ),
      identify: occupant => occupant.employee.id,
      name: ec.Name.Predefined.SpaceOccupant,
    })

    this.feature.registerEffects(
      effects.reloadOnClusterAssignmentChange(this),
      effects.reloadOnClusterOccupantChange(this),
      effects.reloadOnPayrollsUpdate(this),
    )
  }
}
